import axios from 'axios';
import _isEmpty from 'lodash/isEmpty';
import { getCsrfToken } from '../../helpers/twHelper';
import { getUrlWithQueryParams } from '../../helpers/globalHelper';

// Constants
import {
  PERSONALIZED_FEED_API_URL,
  PERSONALIZED_FEED_ERROR,
  PERSONALIZED_FEED_REQUESTED,
  PERSONALIZED_FEED_SUCCESS,
} from '../personalizedSection/PersonalizedSection-Actions';

export const CONTACT_US_TOPIC_TREE_INTENT_URL = '/smarthelp/api/topic-tree';

// constants
export const TOPIC_INTENTS_REQUESTED = 'TOPIC_INTENTS_REQUESTED';
export const TOPIC_INTENTS_SUCCESS = 'TOPIC_INTENTS_SUCCESS';
export const TOPIC_INTENTS_ERROR = 'TOPIC_INTENTS_ERROR';
export const TOPIC_INTENT_SEARCH_SHEET_OPEN = 'TOPIC_INTENT_SEARCH_SHEET_OPEN';
export const TOPIC_INTENT_SEARCH_SHEET_CLOSE = 'TOPIC_INTENT_SEARCH_SHEET_CLOSE';
export const TOPIC_INTENT_FINAL_INTENT_SELECTED = 'TOPIC_INTENT_FINAL_INTENT_SELECTED';
export const TOPIC_INTENT_CHANGE_FINAL_INTENT_REQUESTED = 'TOPIC_INTENT_CHANGE_FINAL_INTENT_REQUESTED';
export const RESET_SELECTED_TOPIC = 'RESET_SELECTED_TOPIC';
export const OCP_PROMPT_CARD_SELECTED = 'OCP_PROMPT_CARD_SELECTED';
export const OCP_PROMPT_CARD_CHANGE_REQUESTED = 'OCP_PROMPT_CARD_CHANGE_REQUESTED';

export const requestTopicIntents = () => ({
  type: TOPIC_INTENTS_REQUESTED,
  payload: undefined,
});

export const receiveTopicTreeIntents = ({ topicIntents, priorityIntents }) => ({
  type: TOPIC_INTENTS_SUCCESS,
  payload: {
    topicIntents,
    priorityIntents,
  },
});

export const receiveTopicTreeIntentsError = () => ({
  type: TOPIC_INTENTS_ERROR,
});

export const searchSheetOpen = () => ({
  type: TOPIC_INTENT_SEARCH_SHEET_OPEN,
});

export const searchSheetClose = () => ({
  type: TOPIC_INTENT_SEARCH_SHEET_CLOSE,
});

export const finalIntentSelected = (selectedFinalIntent) => ({
  type: TOPIC_INTENT_FINAL_INTENT_SELECTED,
  payload: selectedFinalIntent,
});

export const resetSelectedIntent = () => ({
  type: RESET_SELECTED_TOPIC,
});

export const ocpPromptCardSelected = (data) => ({
  type: OCP_PROMPT_CARD_SELECTED,
  payload: data,
});

export const ocpPromptChangeSelected = () => ({
  type: OCP_PROMPT_CARD_CHANGE_REQUESTED,
});

export const changeSelected = () => ({
  type: TOPIC_INTENT_CHANGE_FINAL_INTENT_REQUESTED,
});

// Personalized Feed Actions
const requestPersonalizedFeed = () => ({ type: PERSONALIZED_FEED_REQUESTED });

const receivedPersonalizedFeedError = (e) => ({ type: PERSONALIZED_FEED_ERROR, payload: e });

const receivedPersonalizedFeed = (pfData) => {
  const ocp = pfData.ocp || {};
  const isOcpEnabled = !_isEmpty(ocp) && Array.isArray(ocp.intentDetails) && ocp.intentDetails.length > 0;
  return {
    type: PERSONALIZED_FEED_SUCCESS,
    payload: {
      ocp,
      isOcpEnabled,
    },
  };
};

export const getContactTopicTreeIntents = () => (dispatch) => {
  dispatch(requestTopicIntents());
  return axios
    .get(CONTACT_US_TOPIC_TREE_INTENT_URL)
    .then((response) => {
      dispatch(receiveTopicTreeIntents(response.data));
    })
    .catch(() => {
      dispatch(receiveTopicTreeIntentsError());
    });
};

/**
 * fetch personalized info - OCP Data
 */
export const getPersonalizedFeed = () => (dispatch) => {
  dispatch(requestPersonalizedFeed());
  let personalizedFeedUrl = `${getUrlWithQueryParams(PERSONALIZED_FEED_API_URL, {
    pathName: 'contactUs',
    ocp: true,
    trackers: false,
  })}`;

  // remove the '&' from end of the url
  personalizedFeedUrl = personalizedFeedUrl.slice(0, -1);

  return axios
    .get(personalizedFeedUrl)
    .then((feedResponse) => {
      dispatch(receivedPersonalizedFeed(feedResponse.data));
    })
    .catch((e) => dispatch(receivedPersonalizedFeedError(e)));
};

/**
 * Server side FPTI when the OCP Prompts are shown
 * @param {*} intentArticles
 * @returns
 */
export const doServerSideFptiCall = (intentArticles) =>
  axios
    .post('/smarthelp/server-side-fpti', { intentArticles, _csrf: getCsrfToken() })
    .then(() => null)
    .catch(() => null);
